export const CHAINS = [
  { key: 'bsc', label: 'BSC', enabled: true },
  { key: 'eth', label: 'ETH', enabled: false },
  { key: 'base', label: 'Base', enabled: false },
  { key: 'sol', label: 'SOL', enabled: false },
];

export const BABYDOGE_ADDRESS = '0xc748673057861a797275cd8a068abb95a902e8de';

export function isValidEvmAddress(address) {
  return /^0x[a-fA-F0-9]{40}$/.test(address.trim());
}

export function formatUsd(value) {
  if (value === null || value === undefined) return '暂无数据';
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: value >= 1 ? 2 : 8 })}`;
}

export function formatPercent(value) {
  if (value === null || value === undefined) return '暂无数据';
  return `${value > 0 ? '+' : ''}${Number(value).toFixed(2)}%`;
}

export function shortenAddress(address) {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

export function riskTone(level) {
  if (level === '低风险') return 'safe';
  if (level === '中风险') return 'medium';
  if (level === '高风险') return 'high';
  return 'critical';
}
